import React, { useEffect, useState } from "react";
import axios from "axios";
import MaterialTable from "material-table";
import moment from "moment";
import ChangePasswordModal from './ChangePasswordModal';

export default function Users() {
  const [entries, setEntries] = useState({
    data: [{ id: "", name: "", role: "", creationDate: "" }]
  });
  const [state] = useState({
    columns: [
      { title: "Nombre", field: "name" },
      {
        title: "Apellido",
        field: "lastName"
      },
      { title: "Correo electrónico", field: "email" },
      { title: "Documento", field: "documentNumber" },
      {
        title: "Rol",
        field: "role",
        lookup: {},
        render: rowData => rowData.role
      },
      { title: "Fecha de creación", field: "creationDate" }
    ]
  });

  const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    axios.get(process.env.REACT_APP_BASE_URL + "/users")
      .then(response => {
        const data = response.data.map(el => ({
          id: el.id,
          name: el.name,
          lastName: el.lastName,
          email: el.email,
          documentNumber: el.documentNumber,
          role: el.role,
          creationDate: moment(new Date(el.creationDate)).format("DD/MM/YYYY HH:mm:ss")
        }));
        setEntries({ data });
      })
      .catch(error => {
        console.log(error);
        localStorage.clear();
      });

    axios.get(process.env.REACT_APP_BASE_URL + "/users/roles")
      .then(response => {
        const rolesData = response.data.reduce((acc, role) => {
          acc[role] = role;
          return acc;
        }, {});
        state.columns[4].lookup = rolesData;
      })
      .catch(error => {
        console.log("Error fetching roles:", error);
      });
  }, [state.columns]);

  const handleOpenChangePasswordModal = (user) => {
    setSelectedUser(user);
    setOpenChangePasswordModal(true);
  };

  const handleCloseChangePasswordModal = () => {
    setOpenChangePasswordModal(false);
    setSelectedUser(null);
  };

  return (
    <>
      <MaterialTable
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} de {count}",
            labelRowsPerPage: "Filas por página",
            labelRowsSelect: "Filas",
            firstAriaLabel: "Primera página",
            firstTooltip: "Primera página",
            previousAriaLabel: "Página anterior",
            previousTooltip: "Página anterior",
            nextAriaLabel: "Próxima página",
            nextTooltip: "Próxima página",
            lastAriaLabel: "Última página",
            lastTooltip: "Última página"
          },
          toolbar: {
            nRowsSelected: "{0} filas(s) seleccionadas",
            searchTooltip: "Buscar",
            searchPlaceholder: "Buscar"
          },
          header: {
            actions: "Acciones"
          },
          body: {
            emptyDataSourceMessage: "No hay usuarios para mostrar",
            deleteTooltip: "Eliminar",
            editTooltip: "Editar",
            filterRow: {
              filterTooltip: "Filtrar"
            },
            editRow: {
              saveTooltip: "Guardar",
              cancelTooltip: "Cancelar",
              deleteText: "¿Está seguro que desea eliminar el usuario?"
            }
          }
        }}
        title="Gestion de usuarios"
        columns={state.columns}
        data={entries.data}
        editable={{
          onRowUpdate: (newData, oldData) =>
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                const data = [...entries.data];
                const position = data.indexOf(oldData);
                data[position] = newData;
                axios.put(`${process.env.REACT_APP_BASE_URL}/users/${oldData.id}`, newData);
                setEntries({ ...entries, data });
              }, 600);
            })
        }}
        options={{
          headerStyle: {
            textAlign: "left",
            paddingLeft: '16px',
          },
          emptyRowsWhenPaging: false,
          minBodyHeight: "auto",
        }
        }
        actions={[
          {
            icon: 'lock',
            tooltip: 'Cambiar contraseña',
            onClick: (event, rowData) => handleOpenChangePasswordModal(rowData)
          }
        ]}
      />
      <ChangePasswordModal
        open={openChangePasswordModal}
        onClose={handleCloseChangePasswordModal}
        user={selectedUser}
      />
    </>
  );
}
